import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { supervision: () => import('./SupervisionPage.vue') },
} satisfies FeatureRoutes
